module.exports = __webpack_public_path__ + "img/go-back-arrow.f150a18e.png";